import { themeStyle } from '@repo/ui/theming';

export const newProjectButtonTheme = {
  fontSize: themeStyle.fontSize10,
  gap: '7px',
  padding: '10px',
};
